import { action } from 'typesafe-actions';
import { UserFund } from 'src/types';
import { ShoppingCartActionTypes as act } from './actionTypes';

export const INVESTED_EVERY_MONTH = 'investedEveryMonth';
export const TRANSFER_DAYS = 'transferDays';
export const TRANSFER_MONTHS = 'transferMonths';

export default function shoppingCart(
  state = {
    cartLookup: {},
    newFunds: [],
    error: null,
    errorMessage: null,
    transactionType: null,
  },
  { payload, type }
) {
  switch (type) {
    case act.SELECT_FUND:
    case act.DESELECT_FUND:
    case act.UPDATE_FUND_AMOUNT: {
      const { cartLookup } = state;
      const { agreementID, amount, amountField, BPID, isIRA, poaParty } =
        payload;
      const newCartItem = cartLookup[agreementID] || {};
      newCartItem.selected = type !== act.DESELECT_FUND;
      newCartItem.BPID = BPID;
      newCartItem.isIRA = isIRA;
      newCartItem.poaPartyID = poaParty ? poaParty : undefined;
      if (type === act.UPDATE_FUND_AMOUNT) {
        newCartItem[amountField] = amount;
      }
      return {
        ...state,
        cartLookup: {
          ...cartLookup,
          [agreementID]: newCartItem,
        },
      };
    }
    case act.UPDATE_MONTH_SELECTION: {
      const { cartLookup } = state;
      const { agreementID, month, monthField, BPID, isAllSelected } = payload;
      const newCartItem = cartLookup[agreementID] || {};
      newCartItem.selected = type !== act.DESELECT_FUND;
      newCartItem.BPID = BPID;
      newCartItem[INVESTED_EVERY_MONTH] = isAllSelected;
      newCartItem[monthField] = month;
      return {
        ...state,
        cartLookup: {
          ...cartLookup,
          [agreementID]: newCartItem,
        },
      };
    }
    case act.UPDATE_DAY_SELECTION: {
      const { cartLookup } = state;
      const { agreementID, day, dayField, BPID } = payload;
      const newCartItem = cartLookup[agreementID] || {};
      newCartItem.selected = type !== act.DESELECT_FUND;
      newCartItem.BPID = BPID;
      newCartItem[dayField] = day;
      return {
        ...state,
        cartLookup: {
          ...cartLookup,
          [agreementID]: newCartItem,
        },
      };
    }
    case `${act.GET_RECURRING_START_DATE_DATA}_FULFILLED`: {
      const {
        body: { systematicsSelections },
      } = payload;
      let { cartLookup } = state;
      systematicsSelections.forEach((fund) => {
        const { agreementID, startDate } = fund;
        const newCartItem = cartLookup[agreementID] || {};
        newCartItem['startDate'] = startDate;
        cartLookup = { ...cartLookup, [agreementID]: newCartItem };
      });
      return {
        ...state,
        cartLookup: {
          ...cartLookup,
        },
      };
    }
    case `${act.ADD_TO_NEW_FUND}_FULFILLED`:
      return {
        ...state,
        newFunds: [...state.newFunds, payload],
      };
    case `${act.ADD_TO_NEW_FUND_ERROR}`:
      return {
        ...state,
        error: true,
        errorMessage: 'Unable to add to fund',
      };
    case `${act.EMPTY_NEW_FUND}_FULFILLED`:
      return {
        ...state,
        newFunds: [],
      };
    case `${act.EMPTY_NEW_FUND_ERROR}`:
      return {
        ...state,
        error: true,
        errorMessage: 'Unable to empty newFund',
      };
    case `${act.SWAP_NEW_FUND}`:
      const { agreementID, fund } = payload;
      const { cartLookup, newFunds } = state;
      return {
        ...state,
        cartLookup: {
          ...cartLookup,
          [agreementID]: fund,
        },
        newFunds: newFunds.map((f: UserFund) =>
          f.agreementID === agreementID ? fund : f
        ),
      };
    case `${act.RESET_TRANSACTION}`:
      return {
        ...state,
        cartLookup: {},
        newFunds: [],
      };
    default:
      return state;
  }
}

export const addToNewFund = (newFunds) => {
  return (dispatch: CallableFunction) => {
    dispatch(action(`${act.ADD_TO_NEW_FUND}_FULFILLED`, newFunds));
  };
};

export const emptyNewFund = () => {
  return (dispatch: CallableFunction) => {
    dispatch(action(`${act.EMPTY_NEW_FUND}_FULFILLED`, null));
  };
};

export function selectFund(agreementID, fund, BPID) {
  return action(act.SELECT_FUND, { agreementID, fund, BPID });
}

export function deselectFund(agreementID, BPID) {
  return action(act.DESELECT_FUND, { agreementID, BPID });
}

export function swapFund(agreementID, fund) {
  return action(act.SWAP_NEW_FUND, { agreementID, fund });
}

export function updateFundAmount(
  agreementID,
  amount,
  amountField,
  BPID,
  isIRA,
  poaParty
) {
  return action(act.UPDATE_FUND_AMOUNT, {
    agreementID,
    amount,
    amountField,
    BPID,
    isIRA,
    poaParty,
  });
}

export function updateMonthSelection(
  agreementID,
  month,
  monthField,
  BPID,
  isAllSelected
) {
  return action(act.UPDATE_MONTH_SELECTION, {
    agreementID,
    month,
    monthField,
    BPID,
    isAllSelected,
  });
}

export function updateDaySelection(agreementID, day, dayField, BPID) {
  return action(act.UPDATE_DAY_SELECTION, {
    agreementID,
    day,
    dayField,
    BPID,
  });
}

export function resetTransaction() {
  return action(act.RESET_TRANSACTION, {});
}
